import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {LocalStorage} from "../../utils/LocalStorage";
import {Switch} from "../buttons/Swtich";
import {YesNoModal} from "../elements/YesNoModal";
import {FaIcon} from "../FaIcon";
import {withTranslation} from 'react-i18next';

// Configuración del cliente — dos zonas separadas:
//   1) ESTADO (warning, ámbar): activar/desactivar el cliente.
//   2) ZONA DE PELIGRO (rojo): borrar. Sólo disponible si el cliente está INACTIVO
//      (mientras está activo, el borrado se muestra deshabilitado + se explica por qué).
// Endpoints existentes: PUT client/{id}/activate|deactivate ; DELETE client/{id}/delete.
class ClientDangerZoneClass extends Component {
    constructor(props) {
        super(props);
        this.state = {active: null, loading: true};
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    componentDidMount() {
        this.fetchStatus();
    }

    fetchStatus() {
        new APIClient(API_URL + 'client/' + this.props.clientId).call('GET').then((data) => {
            if (data && data.status === 'OK') {
                const d = data.data || {};
                const active = (d.is_active !== undefined)
                    ? !!d.is_active
                    : (d.active !== undefined ? !!d.active : true);
                this.setState({active, loading: false});
            } else {
                this.setState({active: true, loading: false});
            }
        });
    }

    handleStatusChange(isActive) {
        const {t} = this.props;
        const action = isActive ? 'activate' : 'deactivate';
        const prev = this.state.active;
        this.setState({active: isActive});  // optimista
        new APIClient(API_URL + 'client/' + this.props.clientId + '/' + action)
            .call('PUT', {add_ada_to_cli_if_none: false})
            .then((data) => {
                if (!data || data.status !== 'OK') {
                    this.setState({active: prev});  // revertir
                    alert((data && data.error_message) || t('client_danger_zone.status_error', 'No se pudo cambiar el estado del cliente.'));
                }
            });
    }

    handleDelete() {
        const {t} = this.props;
        new APIClient(API_URL + 'client/' + this.props.clientId + '/delete').call('DELETE').then((data) => {
            if (data && data.status === 'OK') {
                if (this.props.navigate) this.props.navigate('/agency/clients');
            } else {
                alert((data && data.error_message) || t('client_danger_zone.delete_error', 'No se pudo borrar el cliente.'));
            }
        });
    }

    renderStatusZone() {
        const {t} = this.props;
        const active = this.state.active;
        return (
            <div className="box client-status-zone">
                <header className="box-header client-status-zone__header">
                    <h2 className="box-title">{t('client_danger_zone.status_title', 'Estado del cliente')}</h2>
                </header>
                <div className="danger-zone-row">
                    <div className="danger-zone-row__text">
                        <strong>
                            {active
                                ? t('client_danger_zone.deactivate_label', 'Desactivar cliente')
                                : t('client_danger_zone.activate_label', 'Activar cliente')}
                        </strong>
                        <p>{t('client_danger_zone.status_help', 'Afecta a todos los usuarios de la agencia: el cliente se oculta de los listados y deja de monitorearse para todos. Podés reactivarlo cuando quieras.')}</p>
                    </div>
                    <div className="client-status-zone__toggle">
                        <Switch checked={active} onChange={(e) => this.handleStatusChange(e.target.checked)}/>
                        <span className="status-label">
                            {active ? t('status.active', 'Activo') : t('status.inactive', 'Inactivo')}
                        </span>
                    </div>
                </div>

                <p className="client-status-zone__note">
                    <FaIcon iconName="info-circle"/>
                    <span>
                        {t('client_danger_zone.assign_note', '¿Solo querés sumarte o sacarte este cliente a vos (sin afectar a los demás)? Hacelo desde')}{' '}
                        <Link to={'/user/' + LocalStorage.fetchUserId() + '/module/marketing'}>
                            {t('client_danger_zone.assign_note_link', 'Mis clientes')}
                        </Link>.
                    </span>
                </p>
            </div>
        );
    }

    renderDangerZone() {
        const {t} = this.props;
        const active = this.state.active;
        return (
            <div className="box client-danger-zone">
                <header className="box-header client-danger-zone__header">
                    <h2 className="box-title">{t('client_danger_zone.title', 'Zona de peligro')}</h2>
                </header>
                <div className="danger-zone-row">
                    <div className="danger-zone-row__text">
                        <strong>{t('client_danger_zone.delete_label', 'Eliminar cliente')}</strong>
                        <p>
                            {active
                                ? t('client_danger_zone.delete_blocked', 'Para borrar un cliente primero tenés que desactivarlo. Así evitás eliminar por error uno que está en uso.')
                                : t('client_danger_zone.delete_desc', 'Esta acción es permanente y no se puede deshacer.')}
                        </p>
                    </div>
                    {active ? (
                        <button
                            type="button"
                            className="client-danger-zone__delete-btn -disabled"
                            disabled
                            title={t('client_danger_zone.delete_blocked_tooltip', 'Desactivá el cliente para poder borrarlo')}
                        >
                            <FaIcon iconName="trash"/>
                            <span>{t('client_danger_zone.delete_label', 'Eliminar cliente')}</span>
                        </button>
                    ) : (
                        <YesNoModal
                            onYesAnswer={this.handleDelete}
                            title={t('client_danger_zone.delete_title', 'Eliminar cliente')}
                            message={t('client_danger_zone.delete_message', 'Se eliminará el cliente de forma permanente.')}
                            question={t('client_danger_zone.delete_question', '¿Querés continuar?')}
                            buttonClassName="client-danger-zone__delete-btn"
                            buttonText={t('client_danger_zone.delete_label', 'Eliminar cliente')}
                            buttonIconName="trash"
                        />
                    )}
                </div>
            </div>
        );
    }

    render() {
        if (this.state.loading) return null;
        return (
            <>
                {this.renderStatusZone()}
                {this.renderDangerZone()}
            </>
        );
    }
}

export const ClientDangerZone = withTranslation()(ClientDangerZoneClass);
export default ClientDangerZone;
